// extracted by mini-css-extract-plugin
export default {"Layout":"Home_Layout__bXvcZ"};